export enum Permission {
  AioliExecute = 'aioli.execute',
}
